import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
//import { connect } from 'react-redux';
//import { bindActionCreators} from 'redux';

export default class Mahler5Timeline extends Component {
	constructor(props){
		super(props);
	}
	render(){
		return (
				<svg id="timeline" xmlns="http://www.w3.org/2000/svg"  version="1.1" viewBox="28 28.5 1314.9455 222.5" width={this.props.width} height={this.props.height}>
  <defs>
    <font-face fontFamily="Gill Sans" fontSize="16" panose-1="2 11 5 2 2 1 4 2 2 3" units-per-em="1000" underline-position="-75.19531" underline-thickness="49.80469" slope="0" x-height="449.70703" cap-height="687.0117" ascent="917.9688" descent="-230.46875" font-weight="400">
      <font-face-src>
        <font-face-name name="GillSans"/>
      </font-face-src>
    </font-face>
    <font-face fontFamily="Gill Sans" fontSize="19" panose-1="2 11 7 2 2 1 4 2 2 3" units-per-em="1000" underline-position="-75.19531" underline-thickness="49.80469" slope="0" x-height="456.0547" cap-height="682.1289" ascent="942.8711" descent="-250" font-weight="600">
      <font-face-src>
        <font-face-name name="GillSans-SemiBold"/>
      </font-face-src>
    </font-face>
  </defs>
  <metadata> Produced by OmniGraffle 7.9.4 2019-01-09 17:39:16 +0000
  </metadata>
  <g strokeOpacity="1" stroke="none" fill="none" fillOpacity="1" strokeDasharray="none">
    <title>Canvas 1</title>
    <g>
      <title>Layer 1</title>
      <g id="Graphic_259" className={"performance leinsdorf conductor-leinsdorf"+(this.props.conductor=="leinsdorf" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="731.7182" y="29" width="102" height="29" fill="white"/>
        <text transform="translate(733.7182 34)" >
          <tspan x="0" y="15">Erich Leinsdorf</tspan>
        </text>
				<g id="Graphic_260" className="subperformance leinsdorf-mahler-5-1976">
					<circle cx="771.7" cy="145.25" r="5.75000918793583"/>
				// </g>
				// <g id="Line_257">
					<line x1="732.25" y1="139.5" x2="732.25" y2="37.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_254" className="subperformance leinsdorf-mahler-5-1972">
					<circle cx="732.25" cy="145.25" r="5.75000918793589" fill="#f14139"/>
				// </g>
				// <g id="Line_323">
					<path d="M 771.7 139.5 L 771.7 137.25 L 771.7 54.5 L 747.5 54.5 L 732 54.5 L 732 29.5 L 732.25 29.5 L 732.25 37.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Line_5">
        <line x1="44" y1="144" x2="44" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_6">
        <line x1="154.18182" y1="144" x2="154.18182" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_7">
        <line x1="55.01818" y1="158.5" x2="55.01818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_8">
        <line x1="66.03636" y1="158.5" x2="66.03636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_9">
        <line x1="77.05455" y1="158.5" x2="77.05455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_10">
        <line x1="88.07273" y1="158.5" x2="88.07273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_11">
        <line x1="99.09091" y1="154.5" x2="99.09091" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_12">
        <line x1="110.10909" y1="158.5" x2="110.10909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_13">
        <line x1="121.12727" y1="158.5" x2="121.12727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_14">
        <line x1="132.14545" y1="158.5" x2="132.14545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_15">
        <line x1="143.16364" y1="158.5" x2="143.16364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_16">
        <line x1="264.36364" y1="144" x2="264.36364" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_17">
        <line x1="165.2" y1="158.5" x2="165.2" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_18">
        <line x1="176.21818" y1="158.5" x2="176.21818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_19">
        <line x1="187.23636" y1="158.5" x2="187.23636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_20">
        <line x1="198.25455" y1="158.5" x2="198.25455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_21">
        <line x1="209.27273" y1="154.5" x2="209.27273" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_22">
        <line x1="220.2909" y1="158.5" x2="220.2909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_23">
        <line x1="231.3091" y1="158.5" x2="231.3091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_24">
        <line x1="242.32727" y1="158.5" x2="242.32727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_25">
        <line x1="253.34545" y1="158.5" x2="253.34545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_76">
        <line x1="374.54545" y1="144" x2="374.54545" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_77">
        <line x1="275.38182" y1="158.5" x2="275.38182" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_78">
        <line x1="286.4" y1="158.5" x2="286.4" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_79">
        <line x1="297.41818" y1="158.5" x2="297.41818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_80">
        <line x1="308.43636" y1="158.5" x2="308.43636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_81">
        <line x1="319.45455" y1="154.5" x2="319.45455" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_82">
        <line x1="330.47273" y1="158.5" x2="330.47273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_83">
        <line x1="341.4909" y1="158.5" x2="341.4909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_84">
        <line x1="352.5091" y1="158.5" x2="352.5091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_85">
        <line x1="363.52727" y1="158.5" x2="363.52727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_116">
        <line x1="484.7273" y1="144" x2="484.7273" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_117">
        <line x1="385.56364" y1="158.5" x2="385.56364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_118">
        <line x1="396.5818" y1="158.5" x2="396.5818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_119">
        <line x1="407.6" y1="158.5" x2="407.6" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_120">
        <line x1="418.6182" y1="158.5" x2="418.6182" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_121">
        <line x1="429.63636" y1="154.5" x2="429.63636" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_122">
        <line x1="440.65455" y1="158.5" x2="440.65455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_123">
        <line x1="451.67273" y1="158.5" x2="451.67273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_124">
        <line x1="462.6909" y1="158.5" x2="462.6909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_125">
        <line x1="473.7091" y1="158.5" x2="473.7091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_126">
        <line x1="705.0909" y1="144" x2="705.0909" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_127">
        <line x1="605.9273" y1="158.5" x2="605.9273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_128">
        <line x1="616.94545" y1="158.5" x2="616.94545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_129">
        <line x1="627.9636" y1="158.5" x2="627.9636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_130">
        <line x1="638.9818" y1="158.5" x2="638.9818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_131">
        <line x1="650" y1="154.5" x2="650" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_132">
        <line x1="661.0182" y1="158.5" x2="661.0182" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_133">
        <line x1="672.0364" y1="158.5" x2="672.0364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_134">
        <line x1="683.05455" y1="158.5" x2="683.05455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_135">
        <line x1="694.0727" y1="158.5" x2="694.0727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_146">
        <line x1="594.9091" y1="144" x2="594.9091" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_147">
        <line x1="495.74545" y1="158.5" x2="495.74545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_148">
        <line x1="506.76364" y1="158.5" x2="506.76364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_149">
        <line x1="517.7818" y1="158.5" x2="517.7818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_150">
        <line x1="528.8" y1="158.5" x2="528.8" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_151">
        <line x1="539.8182" y1="154.5" x2="539.8182" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_152">
        <line x1="550.83636" y1="158.5" x2="550.83636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_153">
        <line x1="561.85455" y1="158.5" x2="561.85455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_154">
        <line x1="572.8727" y1="158.5" x2="572.8727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_155">
        <line x1="583.8909" y1="158.5" x2="583.8909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_156">
        <line x1="815.2727" y1="144" x2="815.2727" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_157">
        <line x1="716.1091" y1="158.5" x2="716.1091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_158">
        <line x1="727.1273" y1="158.5" x2="727.1273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_159">
        <line x1="738.14545" y1="158.5" x2="738.14545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_160">
        <line x1="749.1636" y1="158.5" x2="749.1636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_161">
        <line x1="760.1818" y1="154.5" x2="760.1818" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_162">
        <line x1="771.2" y1="158.5" x2="771.2" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_163">
        <line x1="782.2182" y1="158.5" x2="782.2182" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_164">
        <line x1="793.2364" y1="158.5" x2="793.2364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_165">
        <line x1="804.2545" y1="158.5" x2="804.2545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_166">
        <line x1="925.4545" y1="144" x2="925.4545" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_167">
        <line x1="826.2909" y1="158.5" x2="826.2909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_168">
        <line x1="837.3091" y1="158.5" x2="837.3091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_169">
        <line x1="848.3273" y1="158.5" x2="848.3273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_170">
        <line x1="859.3455" y1="158.5" x2="859.3455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_171">
        <line x1="870.3636" y1="154.5" x2="870.3636" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_172">
        <line x1="881.3818" y1="158.5" x2="881.3818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_173">
        <line x1="892.4" y1="158.5" x2="892.4" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_174">
        <line x1="903.4182" y1="158.5" x2="903.4182" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_175">
        <line x1="914.4364" y1="158.5" x2="914.4364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_176">
        <line x1="1035.6364" y1="144" x2="1035.6364" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_177">
        <line x1="936.4727" y1="158.5" x2="936.4727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_178">
        <line x1="947.4909" y1="158.5" x2="947.4909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_179">
        <line x1="958.5091" y1="158.5" x2="958.5091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_180">
        <line x1="969.5273" y1="158.5" x2="969.5273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_181">
        <line x1="980.5455" y1="154.5" x2="980.5455" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_182">
        <line x1="991.5636" y1="158.5" x2="991.5636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_183">
        <line x1="1002.5818" y1="158.5" x2="1002.5818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_184">
        <line x1="1013.6" y1="158.5" x2="1013.6" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_185">
        <line x1="1024.6182" y1="158.5" x2="1024.6182" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_186">
        <line x1="1145.8182" y1="144" x2="1145.8182" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_187">
        <line x1="1046.6545" y1="158.5" x2="1046.6545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_188">
        <line x1="1057.6727" y1="158.5" x2="1057.6727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_189">
        <line x1="1068.6909" y1="158.5" x2="1068.6909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_190">
        <line x1="1079.7091" y1="158.5" x2="1079.7091" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_191">
        <line x1="1090.7273" y1="154.5" x2="1090.7273" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_192">
        <line x1="1101.7455" y1="158.5" x2="1101.7455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_193">
        <line x1="1112.7636" y1="158.5" x2="1112.7636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_194">
        <line x1="1123.7818" y1="158.5" x2="1123.7818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_195">
        <line x1="1134.8" y1="158.5" x2="1134.8" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_196">
        <line x1="1256" y1="144" x2="1256" y2="177" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_197">
        <line x1="1156.8364" y1="158.5" x2="1156.8364" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_198">
        <line x1="1167.8545" y1="158.5" x2="1167.8545" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_199">
        <line x1="1178.8727" y1="158.5" x2="1178.8727" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_200">
        <line x1="1189.8909" y1="158.5" x2="1189.8909" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_201">
        <line x1="1200.9091" y1="154.5" x2="1200.9091" y2="166.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_202">
        <line x1="1211.9273" y1="158.5" x2="1211.9273" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_203">
        <line x1="1222.9455" y1="158.5" x2="1222.9455" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_204">
        <line x1="1233.9636" y1="158.5" x2="1233.9636" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Line_205">
        <line x1="1244.9818" y1="158.5" x2="1244.9818" y2="162.5" stroke="#b13441" strokeLinecap="round" stroke-linejoin="round" strokeWidth="3"/>
      </g>
      <g id="Graphic_206">
        <text transform="translate(914.4545 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1990</tspan>
        </text>
      </g>
      <g id="Graphic_207">
        <text transform="translate(804.2727 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1980</tspan>
        </text>
      </g>
      <g id="Graphic_208">
        <text transform="translate(694.0909 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1970</tspan>
        </text>
      </g>
      <g id="Graphic_209">
        <text transform="translate(583.9091 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1960</tspan>
        </text>
      </g>
      <g id="Graphic_210">
        <text transform="translate(473.7273 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1950</tspan>
        </text>
      </g>
      <g id="Graphic_211">
        <text transform="translate(363.54545 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1940</tspan>
        </text>
      </g>
      <g id="Graphic_212">
        <text transform="translate(33 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1910</tspan>
        </text>
      </g>
      <g id="Graphic_213">
        <text transform="translate(143.18182 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1920</tspan>
        </text>
      </g>
      <g id="Graphic_214">
        <text transform="translate(253.36364 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">1930</tspan>
        </text>
      </g>
      <g id="Graphic_215">
        <text transform="translate(1245 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">2020</tspan>
        </text>
      </g>
      <g id="Graphic_216">
        <text transform="translate(1131.1697 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">2010</tspan>
        </text>
      </g>
      <g id="Graphic_217">
        <text transform="translate(1024.6364 136.66667) rotate(-90)" fill="#b13441">
          <tspan fontFamily="Gill Sans" fontSize="19" font-weight="600" fill="#b13441" x=".4423828" y="18">2000</tspan>
        </text>
      </g>
      <g id="Graphic_222" className={"performance stransky conductor-stransky stransky-mahler-5-1911"+(this.props.conductor=="stransky" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="52.60909" y="188" width="100" height="29" fill="white"/>
        <text transform="translate(57.60909 193)">
          <tspan x="0" y="15">Josef Stransky</tspan>
        </text>
				<g id="Graphic_219">
					<circle cx="54.75" cy="175.25" r="5.75000918793582"/>
				</g>
				<g id="Line_221">
					<line x1="54.75" y1="181" x2="54.75" y2="209" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_224" className={"performance mengelberg conductor-mengelberg"+(this.props.conductor=="mengelberg" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="218.7909" y="222" width="137" height="29" fill="white"/>
        <text transform="translate(223.7909 227)" fill="#ea292c">
          <tspan x="0" y="15">Willem Mengelberg</tspan>
        </text>
				<g id="Graphic_223" className="subperformance mengelberg-mahler-5-1926">
					<circle cx="220.25" cy="175.25" r="5.75000918793581" />
				// </g>
				// <g id="Line_227">
					<line x1="220.25" y1="181" x2="220.25" y2="242"  strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_229" className="subperformance mengelberg-mahler-5-1927">
					<circle cx="231.75" cy="175.25" r="5.75000918793581" />
				// </g>
				// <g id="Line_319">
					<path d="M 231.75 181 L 231.75 183.25 L 231.75 224.66146 L 226.33333 224.66146 L 220.25 224.66146 L 220.25 228.03693 L 220.25 236.03693" stroke="#f14139" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_233" className={"performance vacchiano-walter-mahler-5 walter vacchiano conductor-walter vacchiano-walter-mahler-5-1932"
				 +(this.props.conductor=="walter" ? " conductor " : " ")+(this.props.performance=="walter-mahler-5-1932" ? " currentperformance" : "")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="284.5" y="189.75" width="98" height="29" fill="white"/>
        <text transform="translate(289.5 194.75)" >
          <tspan x="0" y="15">Bruno Walter</tspan>
        </text>
				<g id="Graphic_231">
					<circle cx="286.9" cy="175.25" r="5.75000918793583" />
				</g>
				<g id="Line_232">
					<line x1="286.9" y1="181" x2="286.9" y2="210" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_235"
				 className={"performance vacchiano-walter-mahler-5 walter vacchiano conductor-walter vacchiano-walter-mahler-5-1947"
										+(this.props.conductor=="walter" ? " conductor " : " ")
				 + (this.props.performance=="walter-mahler-5-1947" ? " currentperformance " : "")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="448.92045" y="189.75" width="98" height="29" fill="white"/>
        <text transform="translate(453.92045 194.75)" fill="#ea292c">
          <tspan  x="0" y="15">Bruno Walter</tspan>
        </text>
				<g id="Graphic_234">
					<circle cx="451.32045" cy="175.25" r="5.75000918793581" />
				</g>
				<g id="Line_236">
					<line x1="451.32045" y1="181" x2="451.32045" y2="210" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_239" className={"performance mitropoulos vacchiano conductor-mitropoulos mitropouslos-mahler-5-1960"
				 +(this.props.conductor=="mitropoulos" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="592.1273" y="218" width="137" height="29" fill="white"/>
        <text transform="translate(597.1273 223)" >
          <tspan  x="0" y="15">Dmitri Mitropoulos</tspan>
        </text>
				<g id="Graphic_238">
					<circle cx="594.9091" cy="174.75" r="5.75000918793587" fill="#f14139"/>
				</g>
				<g id="Line_240">
					<line x1="594.9091" y1="180.5" x2="594.9091" y2="238" stroke="#f14139" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_242" className={"performance bernstein vacchiano conductor-bernstein"
				 +(this.props.conductor=="bernstein" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
				<g className={"conductorName bernstein"+(this.props.performance && this.props.performance.indexOf('bernstein')>-1 ? " currentperformance" : "")}>
					<rect x="625.9636" y="188" width="130" height="29" fill="white"/>
					<text transform="translate(630.9636 193)" >
						<tspan x="0" y="15">Leonard Bernstein</tspan>
					</text>
				</g>
				<g id="Graphic_241" className={"subperformance bernstein-mahler-5-1963"+(this.props.performance=="bernstein-mahler-5-1963" ? " currentperformance" : "")}>
					<circle cx="628.4636" cy="175.25" r="5.75000918793586" />
					<line x1="628.4636" y1="181" x2="628.4636" y2="208.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_246" className="subperformance bernstein-mahler-5-1967">
					<circle cx="670.8909" cy="175.25" r="5.75000918793584"/>
				// </g>
				// <g id="Line_321">
					<path d="M 670.8909 181 L 670.8909 183.25 L 670.94545 183.875 L 671 184.5 L 671 192.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_247" className="subperformance bernstein-mahler-5-1968">
					<circle cx="683.55455" cy="175.25" r="5.75000918793586" />
				// </g>
				// <g id="Line_322">
					<path d="M 683.55455 181 L 683.55455 183.25 L 683.5273 183.875 L 683.5 184.5 L 683.5 192.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Line_320" className="subperformance bernstein-mahler-5-1974">
					<path d="M 749.6636 180.5 L 749.6636 182.75 L 749.5 189 L 749.5 192.5 L 636.4636 192.5 L 628.4636 192.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				// </g>
				// <g id="Graphic_250">
					<circle cx="749.6636" cy="174.75" r="5.75000918793589" fill="#f14139"/>
				</g>
      </g>
      <g id="Graphic_258" className={"performance maazel conductor-maazel vacchiano maazel-mahler-5-1972"
				 +(this.props.conductor=="maazel" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="636.5" y="61.5" width="93" height="29" fill="white"/>
        <text transform="translate(641.5 66.5)" fill="#ea292c">
          <tspan x="0" y="15">Lorin Maazel</tspan>
        </text>
				<g id="Graphic_253">
					<circle cx="727.6273" cy="131.75" r="5.75000918793583" />
				</g>
				<g id="Line_256">
					<line x1="727.6273" y1="126" x2="727.6273" y2="68" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_265" className={"performance david-gilbert conductor-david-gilbert david-gilbert-mahler-5-1977"
				 +(this.props.conductor=="david-gilbert" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="778.4364" y="218" width="98" height="29" fill="white"/>
        <text transform="translate(783.4364 223)" fill="#ea292c">
          <tspan x="0" y="15">David Gilbert</tspan>
        </text>
				<g id="Graphic_264">
					<circle cx="781.2182" cy="174.75" r="5.75000918793583" />
				</g>
				<g id="Line_266">
					<line x1="781.2182" y1="180.5" x2="781.2182" y2="238" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_268" className={"performance mehta conductor-mehta "
				 +(this.props.conductor=="mehta" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="804.2545" y="61.5" width="93" height="29" fill="white"/>
        <text transform="translate(809.2545 66.5)" >
          <tspan x="0" y="15">Zubin Mehta</tspan>
        </text>
				<g id="Graphic_267" className="subperformance mehta-mahler-5-1979">
					<circle cx="805.0227" cy="145.25" r="5.75000918793584" />
				// </g>
				// <g id="Line_269">
					<line x1="805.0227" y1="139.5" x2="805.0227" y2="71" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Line_270">
					<line x1="805.0227" y1="85" x2="915.4364" y2="85" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_271">
					<circle cx="848.65" cy="145.25" r="5.75000918793581" />
				// </g>
				// <g id="Line_275">
					<line x1="848.588" y1="139.50033" x2="848" y2="85"  strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_272">
					<circle cx="860.15" cy="145.25" r="5.75000918793581" />
				// </g>
				// <g id="Line_276">
					<line x1="860.15" y1="139.50104" x2="860.15" y2="85" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_273">
					<circle cx="870.8636" cy="145.25" r="5.75000918793584" />
				// </g>
				// <g id="Line_277">
					<line x1="870.8636" y1="139.50058" x2="870.8636" y2="85"  strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_274">
					<circle cx="914.9364" cy="145.25" r="5.75000918793584" />
				// </g>
				// <g id="Line_278">
					<line x1="914.9364" y1="139.5002" x2="914.9364" y2="85"  strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
			<g id="Tennstedt-1980" className={"performance smith-tennstedt-mahler-5 conductor-tennstedt trumpeter-smith smith-tennstedt-mahler-5-1980"+(this.props.trumpeter =="smith"? " trumpeter ":"")+(this.props.conductor=="tennstedt" ? " conductor " : "") + (this.props.performance=="Tennstedt-1980" ? " currentperformance " : "")} onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
				<g id="Graphic_279" className="Tennstedt1980 Tennstedt">
					<circle cx="815.7727" cy="175.75" r="5.75000918793591"/>
				</g>
				<g id="Graphic_280" className="Tennstedt1980 Tennstedt">
          <rect x="815.2727" y="189.75" width="111" height="29" fill="white"/>
          <text transform="translate(820.2727 194.75)" fill="#ea292c">
            <tspan  x="0" y="15">Klaus Tennstedt</tspan>
          </text>
				</g>
				<g id="Line_281" className="Tennstedt1980 Tennstedt">
					<line x1="815.7727" y1="181.5" x2="815.7727" y2="210" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_283" className={"performance slatkin conductor-slatkin"
				 +(this.props.conductor=="slatkin" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="849.5091" y="29" width="111" height="29" fill="white"/>
        <text transform="translate(854.5091 34)" >
          <tspan x="0" y="15">Leonard Slatkin</tspan>
        </text>
				<g id="Graphic_282">
					<circle cx="957" cy="145.25" r="5.75000918793587" />
				</g>
				<g id="Line_284">
					<line x1="957" y1="144" x2="957" y2="37" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_286" className={"performance tilson-thomas conductor-tilson-thomas"
				 +(this.props.conductor=="tilson-thomas" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="990.8182" y="29" width="156" height="29" fill="white"/>
        <text transform="translate(995.8182 34)" >
          <tspan x="0" y="15">Michael Tilson Thomas</tspan>
        </text>
				<g id="Graphic_285">
					<circle cx="991.1977" cy="145.25" r="5.75000918793584"/>
				</g>
				<g id="Line_287">
					<line x1="991.1977" y1="139.5" x2="991.1977" y2="37" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_289" className={"performance gatti conductor-gatti"
				 +(this.props.conductor=="gatti" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="1010.6568" y="218" width="97" height="29" fill="white"/>
        <text transform="translate(1015.6568 223)" >
          <tspan x="0" y="15">Daniele Gatti</tspan>
        </text>
				<g id="Graphic_288">
					<circle cx="1013.4386" cy="174.75" r="5.75000918793589" />
				</g>
				<g id="Line_290">
					<line x1="1013.4386" y1="180.5" x2="1013.4386" y2="238" stroke="#f14139" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_292" className={"performance fischer conductor-fischer"
				 +(this.props.conductor=="fischer" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="1045.6545" y="58" width="87" height="29" fill="white"/>
        <text transform="translate(1050.6545 63)" fill="#ea292c">
          <tspan x="0" y="15">Ivan Fischer</tspan>
        </text>
				<g id="Graphic_291">
					<circle cx="1046.2886" cy="145.25" r="5.75000918793578" fill="#f14139"/>
				</g>
				<g id="Line_293">
					<line x1="1046.2886" y1="139.5" x2="1046.2886" y2="66" stroke="#f14139" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_295" className={"performance maazel conductor-maazel"
				 +(this.props.conductor=="maazel" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="1068.1909" y="187" width="93" height="29" fill="white"/>
        <text transform="translate(1073.1909 192)" >
          <tspan x="0" y="15">Lorin Maazel</tspan>
        </text>
				<g id="Graphic_294">
					<circle cx="1070.6909" cy="174.25" r="5.75000918793579" />
				// </g>
				// <g id="Line_296">
					<line x1="1070.6909" y1="180" x2="1070.6909" y2="207.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_298">
					<circle cx="1081.075" cy="174.25" r="5.7500091879358" />
				</g>
				<g id="Graphic_300">
					<circle cx="1091.2273" cy="174.25" r="5.7500091879358" />
				</g>
				<g id="Line_325">
					<path d="M 1091.2273 180 L 1091.2273 182.25 L 1091.2273 192 L 1083 192 L 1070.6909 192 L 1070.6909 215.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Line_324">
					<path d="M 1081.075 180 L 1081.075 182.25 L 1081.075 192 L 1076.5 192 L 1070.6909 192 L 1070.6909 215.5 L 1070.6909 215.5 L 1070.6909 207.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_311" className={"performance alan-gilbert conductor-alan-gilbert"
				 +(this.props.conductor=="alan-gilbert" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="1159" y="218" width="90" height="29" fill="white"/>
        <text transform="translate(1164 223)" fill="#ea292c">
          <tspan x="0" y="15">Alan Gilbert</tspan>
        </text>
				<g id="Graphic_310">
					<circle cx="1161.0682" cy="174.25" r="5.75000918793577" />
				</g>
				<g id="Line_312">
					<line x1="1161.0682" y1="180" x2="1161.0682" y2="236.66667" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Line_326">
					<path d="M 1201.4955 180 L 1201.4955 182.25 L 1201.4955 222.5 L 1181 222.5 L 1161.0682 222.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
				<g id="Graphic_314">
					<circle cx="1201.4955" cy="174.25" r="5.75000918793574" />
				</g>
      </g>
      <g id="Graphic_317" className={"performance van-zweden conductor-van-zweden"
				 +(this.props.conductor=="van-zweden" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="1222.9455" y="182" width="120" height="29" fill="white"/>
        <text transform="translate(1227.9455 187)" >
          <tspan x="0" y="15">Jaap van Zweden</tspan>
        </text>
				<g id="Graphic_316">
					<circle cx="1223.4455" cy="174.25" r="5.7500091879358" />
				</g>
				<g id="Line_318">
					<line x1="1223.4455" y1="180" x2="1223.4455" y2="206.5" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
      <g id="Graphic_303" className={"performance dudamel conductor-dudamel"
				 +(this.props.conductor=="dudamel" ? " conductor " : " ")}
				 onMouseEnter={this.props.setConductor} onMouseLeave={this.props.unsetConductor}>
        <rect x="1130.9341" y="59.75" width="127" height="29" fill="white"/>
        <text transform="translate(1135.9341 64.75)" fill="#ea292c">
          <tspan  x="0" y="15">Gustavo Dudamel</tspan>
        </text>
				<g id="Graphic_302">
					<circle cx="1131.5682" cy="147" r="5.75000918793571" />
				</g>
				<g id="Line_304">
					<line x1="1131.5682" y1="141.25" x2="1131.5682" y2="67.75" strokeLinecap="round" stroke-linejoin="round" strokeWidth="2"/>
				</g>
      </g>
    </g>
  </g>
				</svg>);
	}
}
